import { Table } from 'antd';
import type { TableColumnsType } from 'antd';

export const COMPUTING_RESOURCE_OPTIONS = [
  { value: 'c4-basic', label: 'C4-Basic', cpu: '4', memory: '16Gi', gpu: '0' },
  { value: 'c16-pro', label: 'C16-Pro', cpu: '16', memory: '64Gi', gpu: '0' },
  { value: 'c32-max', label: 'C32-Max', cpu: '32', memory: '128Gi', gpu: '0' },
  { value: 'g1-standard', label: 'G1-Standard', cpu: '16', memory: '64Gi', gpu: '1' },
  { value: 'g1-extreme', label: 'G1-Extreme', cpu: '32', memory: '128Gi', gpu: '1' },
];

interface ResourceTierData {
  key: string;
  category: string;
  tier: string;
  gpu: string;
  cpu: string;
  ram: string;
  workload: string;
}

const columns: TableColumnsType<ResourceTierData> = [
  {
    title: '분류',
    dataIndex: 'category',
    key: 'category',
    width: 62,
  },
  {
    title: '티어',
    dataIndex: 'tier',
    key: 'tier',
    width: 122,
  },
  {
    title: (
      <>
        GPU
        <br />
        (VRAM)
      </>
    ),
    dataIndex: 'gpu',
    key: 'gpu',
    width: 82,
  },
  {
    title: (
      <>
        CPU
        <br />
        (Core)
      </>
    ),
    dataIndex: 'cpu',
    key: 'cpu',
    width: 82,
  },
  {
    title: (
      <>
        RAM
        <br />
        (GiB)
      </>
    ),
    dataIndex: 'ram',
    key: 'ram',
    width: 82,
  },
  {
    title: '주요 권장 워크로드',
    dataIndex: 'workload',
    key: 'workload',
  },
];

const dataSource: ResourceTierData[] = [
  {
    key: '1',
    category: 'CPU',
    tier: 'C4-Basic',
    gpu: '미할당',
    cpu: '4',
    ram: '16',
    workload: '코드 디버깅, 소규모 데이터 분석',
  },
  {
    key: '2',
    category: 'CPU',
    tier: 'C16-Pro',
    gpu: '미할당',
    cpu: '16',
    ram: '64',
    workload: '중대형 데이터 처리 및 일반 머신러닝',
  },
  {
    key: '3',
    category: 'CPU',
    tier: 'C32-Max',
    gpu: '미할당',
    cpu: '32',
    ram: '128',
    workload: '메모리 집약적 빅데이터 연산',
  },
  {
    key: '4',
    category: 'GPU',
    tier: 'G1-Standard',
    gpu: '1 (48GB)',
    cpu: '16',
    ram: '64',
    workload: '딥러닝 모델 학습 및 추론',
  },
  {
    key: '5',
    category: 'GPU',
    tier: 'G1-Extreme',
    gpu: '1 (48GB)',
    cpu: '32',
    ram: '128',
    workload: 'LLM 파인튜닝 및 대규모 모델 실험',
  },
];

export const COMPUTING_RESOURCE_TOOLTIP = (
  <Table columns={columns} dataSource={dataSource} pagination={false} size="small" tableLayout="fixed" />
);
